import { render } from "./AudioPlayer.vue?vue&type=template&id=82194622&scoped=true&ts=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=ts"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts"

import "./AudioPlayer.vue?vue&type=style&index=0&id=82194622&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82194622"]])

export default __exports__